import useSystemSetting from "@/hooks/files/use-system-setting";
import useLogger from "@/hooks/use-logger";
import { useEffect } from "react";
import { Outlet } from 'react-router';
import ConditionalLayout from '@/components/layouts/conditional-layout';
import { useUnblockSoundEffect } from '@/hooks/use-unblock-sound-effect';
import ROUTES from '@/routes';
import MessagesIndexRoute from '@/routes/messages/index';
import { useAuthStore } from '@/stores/auth';

export default function MessagesLayout() {
  const { data: systemSetting } = useSystemSetting();
  const logger = useLogger('Sentry');

  useUnblockSoundEffect();

  useEffect(() => {
    if (systemSetting?.sampleRates?.traces) {
      logger.current.info('tracesSampler AuthLayout', systemSetting.sampleRates.traces);
      useAuthStore.getState().updateTraceRate(systemSetting.sampleRates.traces ?? 0.01);
    }
  }, [systemSetting?.sampleRates?.traces]);

  return (
    <ConditionalLayout pathname={ROUTES.MESSAGES.$path()}>
      {(isDesktop, match) => (isDesktop ? <Outlet /> : match ? <MessagesIndexRoute /> : <Outlet />)}
    </ConditionalLayout>
  );
}
